Vue.component('ack-curo-resins-product-menu', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-curo-resins-product-menu',
	mounted() {
		if (this.menuItems?.length > 0 && !this.activeItem) {
			this.menuItemClick(this.menuItems[0]);
		}
	},
	created() {},
	props: {
		menuItems: {
			// :product-info
			type: Array,
			required: true,
		},
		isMobile: {
			type: Boolean,
			required: true,
		},
		activeItem: {
			type: Object,
			required: true,
		},
	},
	computed: {
		//...Vuex.mapGetters('shop', ['productList']),
		...Vuex.mapGetters('resins', ['activeItem']),
		slidesPlanned() {
			return this.isMobile ? 5 : 10;
		},
		notScrollable() {
			return ((this.menuItems && this.menuItems.length) || 0) <= this.slidesPlanned;
		},
		slidesCount() {
			return (this.menuItems && this.menuItems.length) || 0;
		},
		maxStartIndex() {
			return Math.max(0, this.slidesCount - this.slidesPlanned);
		},
		prevDisabled() {
			return this.notScrollable || this.currentSlide <= 0;
		},
		nextDisabled() {
			return this.notScrollable || this.currentSlide >= this.maxStartIndex;
		},
		carouselOptions() {
			let opt = {
				arrows: true,
				dots: false,
				infinite: false,
				slidesToShow: this.slidesPlanned,
				slidesToScroll: 1,
				autoplay: false,
				speed: 200,
				autoplaySpeed: 0,
				cssEase: 'linear',
				//vertical: this.isMobile ? false : true,
				initialSlide: -1,
			};

			return opt;
		},
	},
	data() {
		return {
			//activeItem: null,
			currentSlide: 0,
		};
	},
	methods: {
		...Vuex.mapActions('resins', ['menuItemClick']),
		onPrevClick() {
			if (this.prevDisabled) return;
			if (this.$refs.resinMenuCarousel && this.$refs.resinMenuCarousel.prev) {
				this.$refs.resinMenuCarousel.prev();
			}
			this.currentSlide = Math.max(0, this.currentSlide - 1);
		},
		onNextClick() {
			if (this.nextDisabled) return;
			if (this.$refs.resinMenuCarousel && this.$refs.resinMenuCarousel.next) {
				this.$refs.resinMenuCarousel.next();
			}
			this.currentSlide = Math.min(this.maxStartIndex, this.currentSlide + 1);
		},
		onInit() {
			this.syncCurrentFromRef();
		},
		onReInit() {
			this.syncCurrentFromRef();
		},
		onAfterChange() {
			this.syncCurrentFromRef();
		},
		syncCurrentFromRef() {
			try {
				if (
					this.$refs.resinMenuCarousel &&
					typeof this.$refs.resinMenuCarousel.currentSlide === 'number'
				) {
					this.currentSlide = this.$refs.resinMenuCarousel.currentSlide;
				}
			} catch (e) {}
		},
	},
	beforeDestroy() {},
	watch: {
		menuItems: {
			handler() {
				this.currentSlide = 0;
			},
			deep: false,
		},
		isMobile: {
			handler() {
				this.currentSlide = 0;
			},
			deep: false,
		},
		prop1: {
			handler() {},
			deep: false,
		},
	},
});
